angular.module('gym.contacts').controller('NewContactWaiverCtrl', ["$scope", "$document", "$window", "$rootScope", "$stateParams", "$timeout", "$state", "$filter", "$q", "loadingAnimation", "flash", "WaiverService", "WaiverValidationService", "CreditCardValidationService", "Contact", "waiver", function($scope, $document, $window, $rootScope, $stateParams, $timeout, $state, $filter, $q, loadingAnimation, flash, WaiverService, WaiverValidationService, CreditCardValidationService, Contact, waiver) {
  var checkBypassFamilySelection, checkForMissingDetails, createGDPRData, getPreselectedMembership, initContacts, isCardholderNameProvided, isCreditCard, isPaymentDetailsPresent, isPaymentFormActive, isPaymentFormValid, isPaymentProviderAgreementAccepted, isSignatureReady, isStripeFormActive, isWitnessSignatureReady, mergeContactsDetails, preselectMembershipPlan, recalculateContactsPosition, removeBlankContacts, safeApply, setLinksTarget, submitPaymentDetails, updateMergeTags, validate, validateRequest;
  $scope.currency = $rootScope.gym.currency_symbol;
  $scope.country = $rootScope.gym.country;
  $scope.waiver = waiver.plain();
  $scope.waiver.rootObjectName = 'signed_waiver';
  $scope.signature = {};
  $scope.witnessSignature = {};
  $scope.walletDetails = {};
  $scope.pageParams = {};
  $scope.gymConfig = $rootScope.gym.gym_config;
  $scope.tz = $rootScope.gym.tz;
  $scope.isBankAccountProviderAvailable = WaiverService.isBankAccountProviderAvailable;
  $scope.isCreditCardProviderAvailable = WaiverService.isCreditCardProviderAvailable;
  WaiverService.getEzidebitFees($scope.waiver, $rootScope.gym.id).then(function(fees) {
    return $scope.ezidebitFees = fees;
  });
  $scope.$watch('waiver.signed_waiver_contacts_attributes[0]', WaiverService.syncContactFields($scope.waiver), true);
  getPreselectedMembership = function() {
    return WaiverService.getPreselectedMembership($scope.waiver);
  };
  preselectMembershipPlan = function() {
    var plans, preselectedMembership, waiverForm;
    waiverForm = $scope.waiver.signed_waiver_form_attributes;
    plans = waiverForm.membership_plan_options;
    if (!(waiverForm.membership_options_active && plans.length)) {
      return;
    }
    preselectedMembership = getPreselectedMembership();
    return $scope.waiver.signed_waiver_contacts_attributes.forEach(function(c) {
      return c.membership_plan_id = preselectedMembership != null ? preselectedMembership.id : void 0;
    });
  };
  checkBypassFamilySelection = function() {
    switch (false) {
      case !$scope.isPrefilledNac():
        return $scope.signAs('signed_as_adult_with_family');
      case !$scope.gymConfig.bypass_family_waiver_selection:
        return $scope.signAs('signed_as_adult');
    }
  };
  $scope.isContactPresent = function(item) {
    return !item._destroy;
  };
  $scope.isSignedAsAdult = function() {
    return $scope.waiver.signed_as === 'signed_as_adult';
  };
  $scope.isMember = function() {
    return $scope.waiver.waiver_type === 'member';
  };
  $scope.isPrefilledNac = function() {
    var contact;
    contact = $scope.waiver.signed_waiver_contacts_attributes[0];
    return contact && contact.contact_id && !contact.attending;
  };
  $scope.displayPaymentDetails = function(provider) {
    switch ($scope.walletDetails.payment_method) {
      case 'credit_card':
        return $scope.waiver.credit_card_provider === provider;
      case 'bank_account':
        return $scope.waiver.bank_account_provider === provider;
    }
  };
  $scope.signAs = function(signedAs) {
    $scope.waiver.signed_as = signedAs;
    updateMergeTags();
    $scope.walletDetails = WaiverService.initPaymentDetails($scope.waiver);
    initContacts();
    setLinksTarget();
    createGDPRData();
    return preselectMembershipPlan();
  };
  $scope.selectAttendingDisabled = function(contact) {
    return contact.contact_id && contact.contact_type.toLowerCase() !== 'prospect';
  };
  setLinksTarget = function() {
    return $timeout(function() {
      return angular.element('.panel-body a').each(function(i, element) {
        return element.target = '_blank';
      });
    });
  };
  createGDPRData = function() {
    var createPolicyResponse, paymentPrivacyPolicies, privacyPolicies;
    createPolicyResponse = function(policy) {
      return angular.extend({}, policy, {
        id: void 0,
        privacy_policy_id: policy.id,
        accepted: false,
        policy_heading: policy.derived_heading,
        policy_content: policy.derived_content
      });
    };
    privacyPolicies = $scope.waiver.privacy_policies.filter(function(policy) {
      return policy.context !== 'waiver_payment_authority';
    });
    paymentPrivacyPolicies = $scope.waiver.privacy_policies.filter(function(policy) {
      return policy.context === 'waiver_payment_authority';
    });
    if (privacyPolicies.length) {
      $scope.waiver.privacy_policy_responses_attributes = privacyPolicies.map(createPolicyResponse);
    }
    if (paymentPrivacyPolicies.length) {
      return $scope.waiver.signed_waiver_wallet_detail_attributes.privacy_policy_responses_attributes = paymentPrivacyPolicies.map(createPolicyResponse);
    }
  };
  $scope.isFieldRequired = function(field, first) {
    return WaiverService.isFieldRequired($scope.waiver, field, first);
  };
  $scope.isFieldAvailable = function(field) {
    return WaiverService.isFieldAvailable($scope.waiver, field);
  };
  $scope.isPaymentMethodPresent = function() {
    var walletDetails;
    walletDetails = $scope.waiver.signed_waiver_wallet_detail_attributes;
    return walletDetails.customer_ref && !!walletDetails.last4;
  };
  initContacts = function() {
    var contacts;
    contacts = $scope.waiver.signed_waiver_contacts_attributes;
    contacts.forEach(function(contact, index) {
      if ($scope.isSignedAsAdult() && index > 0) {
        return contact._destroy = 1;
      } else {
        return contact.member_number_read_only = !!contact.member_number;
      }
    });
    if ($scope.waiver.signed_as === 'signed_as_adult') {
      return $scope.waiver.signed_waiver_contacts_attributes = contacts;
    } else {
      if (contacts.length === 1) {
        $scope.addContact();
      }
      return WaiverService.prepopulateChildDetails($scope.waiver);
    }
  };
  recalculateContactsPosition = function() {
    return $scope.waiver.signed_waiver_contacts_attributes.forEach(function(contact, index) {
      return contact.position = index + 1;
    });
  };
  $scope.removeContact = function(contact) {
    var index;
    if (contact.contact_id) {
      contact._destroy = 1;
    } else {
      index = $scope.waiver.signed_waiver_contacts_attributes.indexOf(contact);
      $scope.waiver.signed_waiver_contacts_attributes.splice(index, 1);
    }
    recalculateContactsPosition();
    if ($scope.activeContacts().length === 1) {
      return $scope.addContact();
    }
  };
  mergeContactsDetails = function(contacts) {
    var originalContacts;
    originalContacts = $scope.waiver.signed_waiver_contacts_attributes;
    return $scope.waiver.signed_waiver_contacts_attributes = originalContacts.map(function(contact, index) {
      var updatedContact;
      updatedContact = contacts.find(function(c) {
        return contact.position === c.position;
      }) || {};
      return angular.extend(contact, updatedContact);
    });
  };
  $scope.activeContacts = function() {
    return _.filter($scope.waiver.signed_waiver_contacts_attributes, function(contact) {
      return !contact._destroy;
    });
  };
  $scope.addContact = function() {
    var contact, contacts, plans, preselectedMembership, waiverForm;
    contacts = $scope.waiver.signed_waiver_contacts_attributes;
    waiverForm = $scope.waiver.signed_waiver_form_attributes;
    plans = waiverForm.membership_plan_options;
    preselectedMembership = getPreselectedMembership();
    contact = {
      primary: false,
      attending: true,
      membership_plan_id: preselectedMembership != null ? preselectedMembership.id : void 0
    };
    angular.extend(contact, WaiverService.getParentDetails($scope.waiver));
    $scope.waiver.signed_waiver_contacts_attributes.push(contact);
    return recalculateContactsPosition();
  };
  updateMergeTags = function() {
    var contact, country, waiverDateValue, waiverForm;
    waiverForm = $scope.waiver.signed_waiver_form_attributes;
    contact = $scope.waiver.signed_waiver_contacts_attributes[0];
    country = $scope.waiver.waiver_header_address_country;
    waiverDateValue = $scope.waiver.signed_at ? moment($scope.waiver.signed_at).format('MMMM Do YYYY') : moment().tz($scope.tz).format('MMMM Do YYYY');
    return $scope.waiver.mergedContent = {
      electronic_consent_content: $filter('replaceWaiverMergeTags')(waiverForm.electronic_consent_content, contact, country, waiverDateValue),
      gym_tacs_content: $filter('replaceWaiverMergeTags')(waiverForm.gym_tacs_content, contact, country),
      waiver_release_content: $filter('replaceWaiverMergeTags')(waiverForm.waiver_release_content, contact, country)
    };
  };
  $scope.onAttendingToggle = function(contact) {
    var ref, ref1;
    if (!contact.attending) {
      contact.member_number = void 0;
    }
    if ((ref = $scope.waiver.signed_waiver_form_attributes.family_membership_strategy) === 'every_attendee_pays_membership' || ref === 'each_signee_chooses_own_membership') {
      return contact.membership_plan_id = contact.attending ? (ref1 = getPreselectedMembership()) != null ? ref1.id : void 0 : null;
    }
  };
  $scope.onContactDetailsChanged = function(contactIndex) {
    if (contactIndex !== 0) {
      return;
    }
    return updateMergeTags();
  };
  $scope.isPaymentDetailsInvalid = function() {
    return WaiverValidationService.isPaymentDetailsInvalid($scope.waiver, $scope.walletDetails);
  };
  submitPaymentDetails = function() {
    return WaiverService.setEzidebitCustomerContactDetails($scope.waiver, $scope.country).then(function() {
      return $timeout(function() {
        var signedWaiverWalletDetail;
        $scope.waiver.signed_waiver_wallet_detail_attributes.payment_method = $scope.walletDetails.payment_method;
        signedWaiverWalletDetail = $scope.waiver.signed_waiver_wallet_detail_attributes;
        if (signedWaiverWalletDetail.customer_ref && signedWaiverWalletDetail.active_on_ezidebit) {
          if ($scope.walletDetails.payment_method === 'credit_card') {
            return angular.element('#updateCreditCard').click();
          } else {
            return angular.element('#updateBankAccount').click();
          }
        } else {
          if ($scope.walletDetails.payment_method === 'credit_card') {
            return angular.element('#submitCreditCard').click();
          } else {
            return angular.element('#submitBankAccount').click();
          }
        }
      });
    });
  };
  checkForMissingDetails = function() {
    var invalidForm;
    invalidForm = WaiverValidationService.getInvalidFormName($scope.waiver, $scope.walletDetails);
    return $window.requestAnimationFrame(function() {
      return $timeout(function() {
        var allErrorElements, topmostErrorEl, topmostOffset;
        allErrorElements = document.querySelectorAll('.alert-danger, .questionnaire-error-anchor');
        topmostErrorEl = null;
        topmostOffset = 2e308;
        allErrorElements.forEach(function(el) {
          var offset, rect;
          rect = el.getBoundingClientRect();
          offset = rect.top + window.scrollY;
          if (offset < topmostOffset) {
            topmostOffset = offset;
            return topmostErrorEl = el;
          }
        });
        if (topmostErrorEl != null) {
          window.scrollTo({
            top: topmostOffset - 300,
            behavior: 'smooth'
          });
        } else if (invalidForm) {
          $document.scrollToElementAnimated(angular.element(invalidForm));
        }
        $scope.pageParams.isLoading = false;
        loadingAnimation.hide();
        return flash.error = 'Save failed. Please fix the errors below.';
      }, 0);
    });
  };
  removeBlankContacts = function() {
    $scope.waiver.signed_waiver_contacts_attributes.forEach(function(contact, index) {
      if (!(contact.email || contact.first_name || contact.last_name || index === 0)) {
        if (contact.id) {
          return contact._destroy = 1;
        } else {
          return $scope.waiver.signed_waiver_contacts_attributes.splice(index, 1);
        }
      }
    });
    return recalculateContactsPosition();
  };
  $scope.togglePaymentDetails = function() {
    if ($scope.walletDetails.editable) {
      return $scope.walletDetails = WaiverService.initPaymentDetails($scope.waiver);
    } else {
      return $scope.walletDetails = WaiverService.getNewPaymentDetails($scope.waiver);
    }
  };
  $scope.hasPayment = function() {
    return WaiverService.hasPayment($scope.waiver);
  };
  $scope.isFormReady = function() {
    var waiverForm;
    waiverForm = $scope.waiver.signed_waiver_form_attributes;
    return !$scope.pageParams.isLoading && waiverForm.electronic_consent_acceptance && isPaymentFormValid() && isSignatureReady() && isWitnessSignatureReady();
  };
  isSignatureReady = function() {
    var waiverForm;
    waiverForm = $scope.waiver.signed_waiver_form_attributes;
    if (waiverForm.signature_active) {
      return $scope.signature.signatureDataUrl;
    } else {
      return true;
    }
  };
  isWitnessSignatureReady = function() {
    var waiverForm;
    waiverForm = $scope.waiver.signed_waiver_form_attributes;
    if (waiverForm.witness_signature_active) {
      return $scope.witnessSignature.signatureDataUrl && waiverForm.witness_name;
    } else {
      return true;
    }
  };
  isPaymentFormActive = function() {
    var waiverForm;
    waiverForm = $scope.waiver.signed_waiver_form_attributes;
    return waiverForm.payment_authority_active && $scope.walletDetails.editable;
  };
  isCreditCard = function() {
    return $scope.walletDetails.payment_method === 'credit_card';
  };
  isPaymentFormValid = function() {
    if (!isPaymentFormActive()) {
      return true;
    }
    if (!isPaymentProviderAgreementAccepted()) {
      return false;
    }
    if (!isPaymentDetailsPresent()) {
      return false;
    }
    if (!isCreditCard()) {
      return true;
    }
    return (!isStripeFormActive() || $scope.walletDetails.complete) && isCardholderNameProvided();
  };
  isCardholderNameProvided = function() {
    var ref, ref1, ref2;
    if ((ref = $scope.walletDetails) != null ? ref.nameOnCard : void 0) {
      return CreditCardValidationService.nameValid((ref1 = $scope.walletDetails) != null ? ref1.nameOnCard : void 0);
    } else {
      return !isStripeFormActive() || CreditCardValidationService.nameValid((ref2 = $scope.walletDetails) != null ? ref2.nameOnCard : void 0);
    }
  };
  isStripeFormActive = function() {
    return $scope.waiver.credit_card_provider === 'stripe' && $scope.walletDetails.payment_method === 'credit_card';
  };
  isPaymentDetailsPresent = function() {
    return WaiverValidationService.isPaymentDetailsPresent($scope.walletDetails);
  };
  isPaymentProviderAgreementAccepted = function() {
    return $scope.pageParams.paymentProviderServiceAgreement;
  };
  validateRequest = function() {
    return Contact.all('signed_waivers').doPOST($scope.waiver, 'validate', {
      waiver_id: $stateParams.waiver_id
    });
  };
  validate = function() {
    var deferred;
    deferred = $q.defer();
    validateRequest().then(function() {
      return WaiverValidationService.validateWaiver($scope.waiver).then(function() {
        return deferred.resolve();
      }, function(response) {
        loadingAnimation.hide();
        $scope.waiver.errors = response.data.errors;
        return checkForMissingDetails();
      });
    }, function(response) {
      return deferred.reject(response);
    });
    return deferred.promise;
  };
  $scope.hasQuestionnaireErrors = false;
  $scope.saveWaiver = function() {
    return Contact.all('signed_waivers').post($scope.waiver, {
      waiver_id: $stateParams.waiver_id
    }).then(function(data) {
      var contactId, type;
      type = $stateParams.contactType;
      contactId = $stateParams.contactId;
      $state.go('gym.contacts.edit', {
        contactType: type,
        contactId: contactId
      });
      flash.success = 'Waiver signed successfully';
      return $scope.$emit('waivers:reviews:reload');
    }, function() {
      $scope.pageParams.isLoading = false;
      return loadingAnimation.hide();
    });
  };
  safeApply = function(fn) {
    if (!$scope.$$phase && !$scope.$root.$$phase) {
      return $scope.$apply(fn);
    } else {
      return fn();
    }
  };
  $scope.responseCollectorsByPosition = {};
  $scope.registerQuestionnaireResponseCollector = function(position, fn) {
    return $scope.responseCollectorsByPosition[position] = fn;
  };
  $scope.questionnaireValidators = [];
  $scope.registerQuestionnaireValidator = function(validatorFn) {
    return $scope.questionnaireValidators.push(validatorFn);
  };
  $scope.unRegisterQuestionnaireValidator = function(validatorFn) {
    var idx;
    idx = $scope.questionnaireValidators.indexOf(validatorFn);
    if (idx >= 0) {
      return $scope.questionnaireValidators.splice(idx, 1);
    }
  };
  $scope.validateQuestionnaires = function(callback) {
    var completed, results;
    results = [];
    completed = 0;
    if ($scope.questionnaireValidators.length === 0) {
      callback(true);
      return;
    }
    return $scope.questionnaireValidators.forEach(function(validatorFn) {
      return validatorFn(function(isValid) {
        results.push(isValid);
        completed += 1;
        if (completed === $scope.questionnaireValidators.length) {
          return callback(results.every(Boolean));
        }
      });
    });
  };
  $scope.submit = function() {
    var signature, waiverForm, witnessSignature;
    waiverForm = $scope.waiver.signed_waiver_form_attributes;
    $scope.waiver.signed_waiver_contact_questionnaires_attributes = [];
    $scope.pageParams.isLoading = true;
    loadingAnimation.show();
    angular.forEach($scope.responseCollectorsByPosition, function(collectorFn, pos) {
      var responses;
      if (typeof collectorFn === 'function') {
        responses = collectorFn();
        return Array.prototype.push.apply($scope.waiver.signed_waiver_contact_questionnaires_attributes, responses);
      }
    });
    if (waiverForm.signature_active) {
      signature = $scope.signature.accept();
      if (!signature.isEmpty) {
        waiverForm.signature = signature.dataUrl.replace(/^data:image\/\w*;base64,/, '');
      }
    }
    if (waiverForm.witness_signature_active) {
      witnessSignature = $scope.witnessSignature.accept();
      if (!witnessSignature.isEmpty) {
        waiverForm.witness_signature = witnessSignature.dataUrl.replace(/^data:image\/\w*;base64,/, '');
      }
    }
    if (!waiverForm.payment_authority_active) {
      $scope.waiver.signed_waiver_wallet_detail_attributes = void 0;
    }
    removeBlankContacts();
    return $q.all([
      (function() {
        var deferred;
        deferred = $q.defer();
        if (typeof $scope.validateQuestionnaires === 'function') {
          $scope.validateQuestionnaires(function(isValid) {
            safeApply(function() {
              return $scope.hasQuestionnaireErrors = !isValid;
            });
            return deferred.resolve(isValid);
          });
        } else {
          deferred.resolve(true);
        }
        return deferred.promise;
      })(),
      validate()
    ]).then(function([questionnaireValid]) {
      if (!questionnaireValid) {
        throw new Error();
      }
      return safeApply(function() {
        $scope.hasQuestionnaireErrors = false;
        if (waiverForm.payment_authority_active && $scope.walletDetails.editable) {
          return submitPaymentDetails();
        } else {
          return $scope.saveWaiver();
        }
      });
    }).catch(function(err) {
      return safeApply(function() {
        var ref;
        $scope.pageParams.isLoading = false;
        loadingAnimation.hide();
        flash.error = 'Please fix the errors in the form below.';
        if (err != null ? (ref = err.data) != null ? ref.errors : void 0 : void 0) {
          $scope.waiver.errors = err.data.errors;
          mergeContactsDetails(err.data.signed_waiver_contacts_attributes);
        }
        return checkForMissingDetails();
      });
    });
  };
  return checkBypassFamilySelection();
}]);
